<template>
  <vonap-window
    transition="dialog-scale-transition"
    title="Drawdown confirmation"
    width="320px"
    height="280px"
    :modal="true"
    @success="refresh"
    @close="close"
    :visible="value"
  >
    <v-layout row justify-center>
      <v-card class="mx-auto">
        <v-card-title>
          <span class="title font-weight-bold">Drawdown all selected on</span>
        </v-card-title>
        <v-container grid-list-xl text-xs-center>
          <v-layout row wrap>
            <v-flex xs10 offset-xs1>
              <kendo-datepicker
                v-model="asOfDate"
                :format="'yyyy-MM-dd'"
                style="width: 125px;display:inline-block;"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-container>
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn block color="success" @click="drawdown">Yes</v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn block color="error" @click="close">No</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapWindow from '@/components/VonapWindow'

export default {
  name: 'DrawdownForm',
  components: {
    VonapWindow,
  },
  props: {
    selectedOperations: {type: Array, default: null},
    value: {
      type: Boolean,
    },
    asOfDate: {
      type: String,
    },
  },
  data() {
    return {
      operationModel: {},
    }
  },
  methods: {
    refresh() {
      this.$emit('success')
    },
    close() {
      this.$emit('input', false)
    },
    async drawdown() {
      const response = await axios.post('/api/list/deal/drawdownOperations', {
        operations: this.selectedOperations,
        deliveryDate: this.asOfDate,
        t: new Date().getTime(),
      })
      if (response.status == 200) {
        this.refresh()
      }
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),

    //loadData() {
    //  return this.getDeliverySchedule()
    //},
  },
}
</script>
